import {IController, IModule, IOnChangesObject} from "angular";
import _ from "lodash";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {BrukerRessurs} from "felles/tjenester/ressurser/BrukerRessurs";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {Autentisering} from "felles/tjenester/Autentisering";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {KlientinformasjonFraUserAgent} from "felles/tjenester/KlientinformasjonFraUserAgent";
import moment from "moment";
import {Debugger} from "debug";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";

const debug:Debugger = require('debug')('ListeAktiveAutentiseringstokenKontroller');
const css = require('./listeAktiveAutentiseringstoken.scss');

export class ListeAktiveAutentiseringstokenKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmBrukerListeAktiveAutentiseringstoken', {
              bindings: {
                  bruker: '<'
              },
              controller: ListeAktiveAutentiseringstokenKontroller.forInjisering(),
              template: require('./listeAktiveAutentiseringstoken.html')
          });
    }

    static forInjisering() {
        return [
            Kontekst.regNavn,
            BrukerRessurs.regNavn,
            Autentisering.regNavn,
            MeldingTilBruker.regNavn,
            KlientinformasjonFraUserAgent.regNavn,
            regNavn.gettext.gettextCatalog,
            ListeAktiveAutentiseringstokenKontroller
        ];
    }

    constructor(private kontekst: Kontekst,
                private brukerRes: BrukerRessurs,
                private autentisering: Autentisering,
                private meldingTilBruker: MeldingTilBruker,
                private klientinformasjonFraUserAgent: KlientinformasjonFraUserAgent,
                private gettextCatalog: gettextCatalog) {
    }

    private bruker: l.BrukerModell; //settes via bindings/$onChanges

    aktiveToken: l.TokeninformasjonModell[];

    sesjonsvarighet(token: l.TokeninformasjonModell) {
        return moment(token.utstedelsestidspunkt).twix(token.utloepstidspunkt).humanizeLength();
    }

    erDenneKlienten(token: l.TokeninformasjonModell) {
        return token.id === this.kontekst.aktivtTokenInfo().id;
    }

    erWebklient(token:l.TokeninformasjonModell){
        return token.klientType == l.KlientType.web;
    }

    klientInfo(token:l.TokeninformasjonModell){
        return this.klientinformasjonFraUserAgent.klientinformasjon(token.userAgent, this.erWebklient(token)).beskrivendeStreng;
    }

    ipLokasjon(token:l.TokeninformasjonModell){
        const lokasjon = _([token.ipLokasjon.kontinent, token.ipLokasjon.land, token.ipLokasjon.by])
          .filter(info => !_.isEmpty(info))
          .join(', ');

        return !_.isEmpty(lokasjon) ?
          lokasjon :
          ///tekst som vises dersom vi ikke klarer å avgjøre lokasjonen til en IPadresse
          this.gettextCatalog.getString('ukjent lokasjon')
    }

    loggUtEnhet(token:l.TokeninformasjonModell){
        this.autentisering.loggUtEnhet(token.id)
          .then(() => this.lastToken())
    }

    $onChanges(endringer: IOnChangesObject): void {
        if (changesInneholder(endringer, 'bruker'))
            this.lastToken();
    }

    //hjelpemetoder

    private lastToken(): void {
        this.aktiveToken = this.brukerRes.aktiveAutentiseringstoken(this.bruker.id);
    }

}
